<template lang="pug">
  .userCreate
    .row
      .col-md-4.col-md-offset-4
        h1 {{$options.filters.translate('Add user', lang)}}
        p {{$options.filters.translate('Generates password and send by email', lang)}}.
        .form-group
          label {{$options.filters.translate('User name', lang)}}
          input.form-control(type="text" v-model="nick")
        .form-group
          label {{$options.filters.translate('Email', lang)}}
          input.form-control(type="email" v-model="email")
        h3 {{$options.filters.translate('Roles', lang)}}
        .radio(v-for="(role) in roles")
          label
            input(type="radio" name="roles" :value="role.id" v-model="roleSel")
            | {{role.name}}
        h3 {{$options.filters.translate('Networks', lang)}}
        .checkbox
          label
            input(type="checkbox" @change="changeAllNetworks()")
            | {{$options.filters.translate('All networks', lang)}}
        hr
        .checkbox(v-for="(network, index) in $store.getters.networks" :key="index")
          label
            input(type="checkbox" :value="network.id" v-model="checkedNetworks")
            | {{network.name}}
        transition(name="fade" mode="out-in")
          div
            button.btn.btn-primary(@click="addUser()" v-if="!saving") {{$options.filters.translate('Create and send password', lang)}}
            div(v-else)
              i.fa.fa-spinner.fa-spin.fa-3x.fa-fw
            button.btn.btn-primary.pull-right(@click="addUser(true)" v-if="!saving") {{$options.filters.translate('Create without passwork (Azure login)', lang)}}
            div.pull-right(v-else)
              i.fa.fa-spinner.fa-spin.fa-3x.fa-fw
        .small
          sup *
          | {{$options.filters.translate('all fields required', lang)}}
</template>
<script>
export default {
  name: 'userCreate',
  props: ['lang'],
  data () {
    return {
      saving: false,
      nick: '',
      email: '',
      userNetworks: [],
      checkedNetworks: [],
      all: false,
      roles: [],
      roleSel: 2
    }
  },
  methods: {
    changeAllNetworks () {
      if (this.all) {
        this.checkedNetworks = []
        this.all = false
      } else {
        this.checkedNetworks = this.$store.getters.networks.map((n) => n.id)
        this.all = true
      }
    },
    addUser (nopass = false) {
      if (!this.roleSel) {
        return this.$notify(`${this.$options.filters.translate('Select role', this.lang)} `, 'error')
      }
      if (!this.checkedNetworks.length) {
        return this.$notify(`${this.$options.filters.translate('Select network', this.lang)} `, 'error')
      }
      this.saving = true
      this.$http.post('user/quickRegister', {nick: this.nick, email: this.email.toLowerCase(), networks: this.checkedNetworks, role: this.roleSel, nopass: nopass})
        .then(response => {
          this.saving = false
          return response.json()
        })
        .then(data => {
          if (data) {
            switch (data) {
              case 'ok':
                this.$notify(`${this.$options.filters.translate('User created', this.lang)} `, 'success')
                break
              case 'Email already registered!':
                this.$notify(`${this.$options.filters.translate('Email already registered', this.lang)} `, 'error')
                break
              default:
                this.$notify(`${this.$options.filters.translate('Complete the form', this.lang)} `, 'error')
                break
            }
          }
        })
        .catch(data => {
          this.saving = false
          if (data.body) {
            switch (data.body.code) {
              case 'E_INVALID_NEW_RECORD':
                this.$notify(`${this.$options.filters.translate('Email not valid', this.lang)} `, 'error')
                break
              case 'E_UNIQUE':
                this.$notify(`${this.$options.filters.translate('Username taken', this.lang)} `, 'error')
                break
            }
          }
        })
    }
  },
  beforeCreate () {
    this.$http.get('role/short')
      .then(response => {
        this.saving = false
        return response.json()
      })
      .then(data => {
        this.roles = data
      })
  }
}
</script>
<style lang="sass">
  .userCreate
    .small
      margin-top: 20px
</style>



// WEBPACK FOOTER //
// src/components/user/UserCreate.vue